module.exports = __webpack_public_path__ + "static/media/yams-min.e07b8c24.png";